import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { BucketRow } from '../../types/traffic';
interface SectionSplitChartProps {
  sections: BucketRow[];
}
const axisStyle = {
  fill: 'var(--muted-foreground)',
  fontSize: 11,
  fontFamily: 'Geist Mono'
};
export function SectionSplitChart({
  sections
}: SectionSplitChartProps) {
  if (sections.length === 0) {
    return <p className="py-10 text-center font-mono text-xs text-muted-foreground" data-id="element-415" data-mp="1937piugi60r1">
        No requested URLs recorded yet
      </p>;
  }
  return <div className="h-64 w-full sm:h-72" data-id="element-416" data-mp="1hwayapg7dpfc">
      <ResponsiveContainer width="100%" height="100%" data-id="element-417" data-mp="1hxc8krpea7w0">
        <BarChart data={sections} layout="vertical" margin={{
        top: 4,
        right: 12,
        bottom: 0,
        left: 0
      }} data-id="element-418" data-mp="1muumyxm6lfbe">
          <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" horizontal={false} data-id="element-419" data-mp="1rvi8j3rn53y8" />
          <XAxis type="number" tick={axisStyle} stroke="var(--border)" allowDecimals={false} tickFormatter={value => Number(value) >= 1000 ? `${Math.round(Number(value) / 1000)}k` : String(value)} data-id="element-420" data-mp="1wud0owbi04v0" />
          <YAxis type="category" dataKey="label" tick={axisStyle} stroke="var(--border)" width={104} data-id="element-421" data-mp="cv1b94v5nr0p" />
          <Tooltip cursor={{
          fill: 'var(--muted)'
        }} contentStyle={{
          background: 'var(--popover)',
          border: '1px solid var(--border)',
          borderRadius: 10,
          fontSize: 12,
          color: 'var(--popover-foreground)'
        }} formatter={(value: number, name) => [value.toLocaleString(), name === 'visitors' ? 'Visitors' : 'Requests']} data-id="element-422" data-mp="15j6xjw1uxo2n" />
          <Bar dataKey="requests" fill="var(--chart-3)" radius={[0, 4, 4, 0]} barSize={14} data-id="element-423" data-mp="1jigeixxw0m7o" />
          <Bar dataKey="visitors" fill="var(--chart-2)" radius={[0, 4, 4, 0]} barSize={14} data-id="element-424" data-mp="3dqafrtz9u236" />
        </BarChart>
      </ResponsiveContainer>
    </div>;
}